import { render } from "./advice-detail.vue?vue&type=template&id=af3b2dbe&scoped=true"
import script from "./advice-detail.vue?vue&type=script&lang=js"
export * from "./advice-detail.vue?vue&type=script&lang=js"

import "./advice-detail.vue?vue&type=style&index=0&id=af3b2dbe&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3b2dbe"]])

export default __exports__